// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bah1y6m{justify-content:flex-start}
._1bsb1osq{width:100%}
._1e0c1txw{display:flex}
._2lx21bp4{flex-direction:column}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-picker/dist/esm/ui/link-picker/search-results/search-results-container/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,0BAA0B;AACrC,WAAW,UAAU;AACrB,WAAW,YAAY;AACvB,WAAW,qBAAqB","sourcesContent":["._1bah1y6m{justify-content:flex-start}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._2lx21bp4{flex-direction:column}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
